export default (
  state = {
    isFetchingPersonalDetails: false,
    data: null,
    receivedAt: null
  },
  action,
) => {
  switch (action.type) {
    case 'REQUEST_PERSONAL_DETAILS':
      return {
        ...state,
        isFetchingPersonalDetails: true,
      }
    case 'RECEIVE_PERSONAL_DETAILS':
      return {
        ...state,
        isFetchingPersonalDetails: false,
        data: action.personalDetails,
        receivedAt:Date.now()
      }
    default:
      return state
  }
}
